import type {WorkspaceStorageUsage} from '@reados/contracts';

export function validateStorageUsage(value:WorkspaceStorageUsage):WorkspaceStorageUsage {
  if(!value||!['usedBytes','limitBytes','availableBytes','usedInodes','limitInodes'].every(key=>Number.isSafeInteger(value[key as keyof WorkspaceStorageUsage])&&Number(value[key as keyof WorkspaceStorageUsage])>=0)||value.limitBytes===0||value.limitInodes===0||value.availableBytes>Math.max(value.limitBytes-value.usedBytes,0)||!Number.isFinite(Date.parse(value.measuredAt)))throw new Error('暂时无法读取工作区空间，请重试。');
  return value;
}

export function formatStorageBytes(value:number):string {
  if(!Number.isFinite(value)||value<0)return '—';
  if(value<1024)return `${value} B`;
  const units=['KiB','MiB','GiB','TiB'];
  let amount=value/1024,index=0;
  while(amount>=1024&&index<units.length-1){amount/=1024;index++;}
  return `${amount.toFixed(1)} ${units[index]}`;
}

export function storageStatus(usage:WorkspaceStorageUsage) {
  const byteRatio=usage.usedBytes/usage.limitBytes;
  const inodeRatio=usage.usedInodes/usage.limitInodes;
  const ratio=Math.max(byteRatio,inodeRatio);
  const level=usage.availableBytes===0||ratio>=.95?'critical':ratio>=.8?'warning':'normal';
  const message=usage.usedInodes>=usage.limitInodes?'文件数量已达上限':usage.availableBytes<=0||byteRatio>=1?'工作区空间已满':inodeRatio>=.95?'文件数量接近上限':byteRatio>=.95?'工作区空间即将用尽':inodeRatio>=.8?'文件数量已用 80% 以上':byteRatio>=.8?'工作区空间已用 80% 以上':'';
  return {level,message,byteRatio,inodeRatio} as const;
}

/** The server remains authoritative; this only catches known insufficient capacity before upload. */
export function uploadStorageIssue(usage:WorkspaceStorageUsage,files:readonly Pick<File,'size'>[]):string|null {
  validateStorageUsage(usage);
  if(!files.length)return null;
  if(files.some(file=>!Number.isSafeInteger(file.size)||file.size<0))return '无法确定文件大小，请重新选择文件。';
  const bytes=files.reduce((sum,file)=>sum+file.size,0);
  if(!Number.isSafeInteger(bytes)||bytes<0)return '无法确定文件大小，请重新选择文件。';
  if(usage.usedInodes>=usage.limitInodes)return '工作区文件数量已达上限，请先清理文件。';
  // Each upload owns a directory and a file. Further generated files are enforced by server quota.
  if(files.length*2>usage.limitInodes-usage.usedInodes)return '剩余文件容量不足，请减少上传文件数量或先清理文件。';
  if(bytes>usage.availableBytes)return `上传需要 ${formatStorageBytes(bytes)}，工作区仅剩 ${formatStorageBytes(usage.availableBytes)}。请先清理文件。`;
  return null;
}
